import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import PaymentResult from "@/pages/PaymentResult";
import ClientGallery from "@/pages/ClientGallery";
import "@/index.css";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    window.__lenis = lenis;
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="grain">
      <Toaster theme="dark" position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/espace-client" element={<ClientGallery />} />
          <Route path="/reservation/succes" element={<PaymentResult status="success" />} />
          <Route path="/reservation/annule" element={<PaymentResult status="cancel" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
